import React, { useContext } from "react";
import classNames from "classnames";
import { QuestionContent } from "../QuestionContent";
import { Options } from "../Options";
import { QuestionContext } from "../../context";

export function QuestionMultiChoice({
    className,
    children,
    style
}: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "MultiChoice") throw new Error("error type data");

    return (
        <div
            className={classNames("QuestionMultiChoice", className)}
            style={style}>
            <QuestionContent />
            <Options />

            {children}
        </div>
    );
}
